import { gql } from '@apollo/client';

export const DELETE_RULE_BY_ID = gql`
  mutation deleteRuleById($id: Int) {
    deleteRuleById(id: $id) {
      id
    }
  }
`;
